module.exports = __webpack_public_path__ + "static/img/me6.ab86fbfd.png";